<template>
    <div>
        <Waterfall :list="dataList" :gutter="8" :width="240"
           :breakpoints="waterfallOptions.breakpoints"
           animationEffect="fadeInUp" ref="videoWaterfall"
        >
            <template slot="item" slot-scope="props">

                <!--                    <div class="card">-->
                <!--                        <img :src="props.data.src" alt="" @load="$refs.waterfall.refresh()">-->
                <!--                        ...-->
                <!--                    </div>-->
                <div class="dataItem paddingB20" data-click="viewItem(props)">
                    <div class="imageArea hiddenOverflow relative" style="min-height: 80px;" @click="viewImages(props.data)">
                        <img class="block" :src="props.data.cover" width="100%" height="auto"
                             style="min-height: 60px;" data-load="$refs.videoWaterfall.refresh()"
                             v-if="props.data.cover"/>
                    </div>
<!--                    <div class="hidden">-->
<!--                        <img v-for="imageItem in props.data.imgList" :src="imageItem" v-gallery="imageGroup" />-->
<!--                    </div>-->
                    <div class="marginT12 paddingH8 color101010 font14r hiddenOverflow"
                         style="line-height: 24px; max-height: 48px;" @click="viewImages(props.data)">
                        {{ plainTextToHtml(props.data.content) }}
                    </div>
                    <div class="clearfix marginT8" style="line-height: 24px;">
                        <img class="size24 circle floatL marginR8" :src="props.data.userHead" @click="viewUser(dataItem)"/>
                        <span class="floatL font12r" @click="viewUser(dataItem)">{{ props.data.userName }}</span>
                        <span class="floatR font12r">
                            {{ props.data.fabulous }}
                            <i class="heartIcon size24 alignM floatR"  :class="{active : props.data.isFabulous}" @click="praise(props.data)"></i>
                        </span>
                    </div>
                </div>
            </template>
        </Waterfall>

        <div class="alignCenter paddingV8" v-show="status === 'loading'">
            <i class="icon spinner-loader"></i>
        </div>

        <div class="paddingV16 colorCCC font14r alignC"
             v-show="status == 'ready' &&  dataList.length < 1">
            暂无任何记录
        </div>

        <div class="paddingV16 alignCenter font14r colorCCC"
             v-show="status=='ready' && pagination.current == pagination.totalPage"
             :data-current="pagination.current" :data-total="pagination.totalPage || 0">
            没有更多记录了
        </div>

        <div class="paddingV16 colorCCC font14r alignC"
             v-show="status == 'error'">
            加载数据失败
        </div>

<!--        <div>-->
<!--            <img v-for="(item,index) in activeImages" :key="index" :src="item.url" @click="imageView(index)">-->
<!--        </div>-->
    </div>

</template>

<script>
import generalCmpPart from "@comp/part/generalCmpPart";
import Waterfall from "vue-waterfall-plugin";

import Vue from 'vue';
import imageViewer from "vue-image-viewer";

Vue.use(imageViewer);

// config
import appConfig from '@/appConfig';

import albumApi     from "./albumApi";
import praiseApi    from '@/api/praise';

// util
import appHelper        from '@/util/appHelper';
import dataMixedUtils   from "@/util/dataMixedUtils";
import timerManager     from "@comp/platformApi/timerManager";
import bizTypeEnum from "@data/bizTypeEnum";

const config = {
    apiConfig : {
        list : {
            url : 'portal/user/album/list',
            dataPath : 'data.records',
            totalPagePath : 'data.pages'
        }
    },
};

export default {
    extends : generalCmpPart,
    components : { Waterfall },
    props : {
        userId : String
    },
    data () {
        return {
            apiConfig : config.apiConfig,

            // pageSize : 8,
            enableDataList : true,

            imageGroup : 'imageGroup',

            activeImages : [],

            waterfallOptions : {
                breakpoints : {
                    1200: { //当屏幕宽度小于等于1200
                        rowPerView: 4,
                    },
                    800: { //当屏幕宽度小于等于800
                        rowPerView: 3,
                    },
                    500: { //当屏幕宽度小于等于500
                        rowPerView: 2,
                    }
                }
            }
        }
    },
    methods : {
        viewImages(dataItem) {

            const me = this;
            this.activeImages = [];
            albumApi.getPhotos({
                albumId : dataItem.id,
                limit : 100
            }, (imageList) => {

                for (let i=0; i<imageList.length; i++)
                {
                    me.activeImages.push({
                        // name : '',
                        url : imageList[i].url
                    });
                }
                me.$imageViewer.images(me.activeImages);
                me.$imageViewer.index(0);
                me.$imageViewer.show();
            });
        },
        viewUser(dataItem) {
            appHelper.goToPage('informationUser', {
                id : dataItem.userInfo.userId
            });
        },
        imageView(index) {
            this.$imageViewer.index(index);
            this.$imageViewer.show();
        },
        plainTextToHtml(text) {
            return dataMixedUtils.html.nlToBr(text);
        },
        praise(dataItem) {

            const me = this;

            if (dataItem.isFabulous)
            {
                praiseApi.cancelPraise({
                    bizType : bizTypeEnum.ALBUM.code,
                    id : dataItem.id
                }, () => {
                    appHelper.showHint('取消点赞成功');
                    dataItem.isFabulous = !dataItem.isFabulous;
                    dataItem.fabulous--;
                    me.reloadDataList();
                });
            }
            else
            {
                praiseApi.praise({
                    bizType : bizTypeEnum.ALBUM.code,
                    id : dataItem.id
                }, () => {
                    appHelper.showHint('点赞成功');
                    dataItem.isFabulous = !dataItem.isFabulous;
                    dataItem.fabulous++;
                    me.reloadDataList();
                });
            }
        },
    },
    mounted() {

        if (this.userId)
        {
            this.apiConfig.list.params = {
                userId : this.userId
            }
        }
        this.loadDataList();

        if (appConfig.mode == 'demo')
        {
            this.dataList = dataMixedUtils.array.buildDataList(8, (index) => {

                let item = {
                    id : index,
                    content : dataMixedUtils.array.getRandomItem(config.demoTitleList),
                    cover : appHelper.getRandomCoverImage(),
                    userHead : appHelper.getRandomCoverImage(),
                    userId : 1,
                    userName : dataMixedUtils.string.getRandomNickName(),
                    // createTime : new Date().getTime() - dataMixedUtils.number.getRandomInteger(1000 * 60 * 60 * 24 * 7),
                    // imgList : [],
                    // commentCount : dataMixedUtils.number.getRandomInteger(20),
                    fabulous : dataMixedUtils.number.getRandomInteger(200),
                };
                return item;
            });
        }
    },
    watch : {
        userId() {
            this.apiConfig.list.params = {
                userId : this.userId
            };
            this.reloadDataList();
        }
    }
}
</script>

<style lang="scss" scoped>
.heartIcon {
    display: inline-block;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAIP0lEQVR4Xu1ae5CT1RX/nZvs8tKi4AsUnVqtOK217Vj7T5lSoDJCmaJgkt2FocLoIpuEl5DsQme+Km4Slu7SJLv4qC2KkHxpwcGp0yrIYtux0zLWGaZT7MMOWkWwgJYC+0hyT+fb3SRfdmBz81qY2dw/c8/9/c753XPO/b7vhjDCB43w+FERoJIBI1yBSgmM8ASoNMFKCVRKYIQrUCmBEZ4AlVOgZCWgtb181Shr92xB4lYGJoExGsQfM/CRTOKtDSsdf1HNtk3tkSlWiWlE4hYANwA8lkGfADhGkg553LY/qWLlsitagM3B2LdZsBfATABVFyNk5mNE9EJSUluT2/afwXaGgGOqeh8D88Mgun0oxw1Rwbyzu0e2aI/XnswV5FDzBQsQCEUmg8RzAObk4wAD58EId586skHTtISmxarHXMMaAw0EfC4/LD4D5ie9rpofA+B81qZsCxIgEIrcA4hXQJhUCOnAmn3M8bWA9WdEdE8ROGDwXjp3brHHs+x/+eLkLYBva/QbwkoHAYzNJuPDYBFjmeyUZPnHbTfg9D+PY4IVyamSxAMgXkagnDvclyHgHZD0KpF8uypu+dRqvUKepc8+TxB3CWA2E9kJuMLMz8zvdFeP+5ZWP+98PiLkJYB/a+xmsvIf+xvTwGB8wODlXpfj10MR+5+JjadeuQlEzovaMXckkvKJDatqTwyF1bJtz3XJRHwTER7JEgF42eu0P1g+AULR14jovkzs+Cux/K7HVXNMlbQ5rC+xAD8FYDWLKMhiW+dcaIirPHzBaJ0geh6EUWmfpHzU664xepPSUM6A5p/ocywWvJomYj6BpLjXu8r2gRKTycgX1GuEwK6Bn07EkfjmRmfd+/niGPb+kL6ICDtMa493Ed2uNdjOquApCxAIR/cDZBx1fYPB871Ox14VkgvZ+MPRNgItTyI5o8lZ+4dCcYx1gbD+EoC6FAaB69c7Hc+qYCoJ0BzeM9GC+PFU2jLwe6/TPk2F4GI2xvE3aoKc3uh2vF4MjrF2U+sLN1ZVjT4K6i8rZnrd67LNVsFVEiAQjiwGxIuZOsOjXrdduc5UHCnWxh/S9xFh1gBOoqtq7HiVE0FJAH9Y30jAkyknE/HeyRtWL/64WKdLud4fiq4koq1pzARN9ayy/S0Xh5IAgXa9HYwVA2BJj9Oe6eC5GIZp3heKPiSIYuk+IGj6+hW2N3PRqwkQ1rcDWNLf/NDtddrH5AIe7nl/UJ9HAq9kypS+53Xb0qfWxfxREsAfigaIaH0K5LyMj/+Re9GZ4Q5yKL5AKLIMJIzni74hE3xv4yrHoVw+KgngC+prhcCWdHpJmr7enTu9cpGXct4f1sMENKQxpXWKx73gw1wcSgJsDkamsRC/zYBRi8dpS2dELpLhmA+E9PdBuHmA65jHab9J5Q1RSQBN08ToiVON9/nr+wn4ZFevuENbYzs9HMHl4gi0RxaCxS/S6c/c0ehyZLJhCAAlAYz1/qC+kUTmKASw0+O0L8rlXLnnm4OxawXxn4lg7LgxkiC+y9PgOKLCrSxAS8uL45Kjq9/LZAHAklu9bsdaFaJy2Ph8O68WV1o7Adydxmf+ucflWKrKpyyAARgI68ZRaByJJj60eV32NaqEpbJrbY1NiFfzPgBfzziD0+D43R73opzNL7UmLwH6SmHQkWj8JpnDjS6Hq1TB5cLRtuy6ZsxoixH8V1O2xvOJBTRjndOW14tV3gL0i6A/O/hjBBgdHpddqfHkCnCoeaPmLUJ2AvSldPCMXjA9qPLgMxi7IAH6yiGkbwNh+aByeM7rsterHD+FiPDU1l3XW6yik0B3mtb3ENH89Q223xSCWbAABpkvFA2JQZ+4GLzd22BfCqKCvtJeLIin2nZMslZVGw3vDpNNl5Q8v5hX6qIEGCiHViKsznacd3SdfPcHmqbJQnZl8JpAcPdNoPgB832B8fGUmeY1umwHiuEoWoABEVqI8HiWI4xI16kji4oVYUt49y1Jjr8Boi+Yjp5zxGJuKR7HSyLAwOngIyLjhsh0KiHWffJInXEBUsgu+Tp23ypk/CBAU0zd/qyUck6Tu+Z3hWCWrAleiNwX0p8QhB9mZwLt6Tp1rV3TvpOXCL722G3EfJCAG03BnwHJ+70NNW+VIngDo2QZkHIoENYbATRnZwLtvbrq04fq6+vjKo43h3ZNtZDlDQCTTfb/jcvEfRvddSW7GC2LAAZooF1fC868PvcHQb/qOokFmmbrHUqEQHv0TjAZjc18+fKZtCRmNa6oe1tFwHxsSp4BKfLNodhKJm4zZxkzXhvLV37f7Z7TcyEnW7ZFvyyTZOz8dab501LKWY3umnfyCUzVtmwC9GVCMOaE4GC2CLy/+1TXPE17uNvsZEvHL7+SlMkDBEw01fwpi7DMWLdi4WHVgPK1K6sAfSKE9OUgdGSJAO6s7hVz16yxdRk2vmDka0KI/QAmmAL4RFh45rrH1P9YkW/wZesBgx3xB/VHSOBpACI9x3hTdPfMTYyzTBVJ634QrjKtOw7iGarv9IUEnlpT9gxI94SwvpSB57NPBxwi4IsAxpt+P5bk5MwmV+27xQSmunbYBOgrh3BsMbPcTkSZTMhW5MMk8cwmp+PvqgEUazesAhjO+kORWqK+azZLtvP8bymqpjeuWPCvYoPKZ/2wC2A4tzkUsTPES6nLTDC/JxM8q3F1zdF8nC+F7SURoK/zh2MPCLAO5qPgqhkq3/BLEfBgjEsmQH85RO9PxHsOb1yz5KNyBKeCeUkFUHGw3DYVAcqt8OWOX8mAy32Hyu1fJQPKrfDljl/JgMt9h8rt3/8BlTDaX8NxJJMAAAAASUVORK5CYII=');
    &.active {
        display: inline-block;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAFPklEQVR4Xu2aXWgcVRTH/2e2jbUGFXxo/YjWmVR8EV+qTxZLEloaLdQKMbtJCFbUqgWRilRUCBYUqVrwo0qLNg1pJvqgKAhaRWyFihYpFEEtu9lEkzW0tdhYN8bszJGdnWR3NpvOvTOzH2VnXjbsnPM/5/zm3HtmdkKo84PqvH6EAMIOqHMC4RKo8wYIN8FwCYRLoM4JhEugzhsgnAKBLQE+sOpqLItsAJMK8LUAlgH0B5gnEMEx6kz8JNptrGtNAK8FKzeBeCUYy0E4DVAKpnGcupI/iGq52fkGwEOr7gZFdgLUCmDpogEZKZB5EJH0HuqYPFNsZwG8bMljAD8IotUuiU+A+RAwvZtiqbNuRV7svGcArDddB27YD6J2uQQ4DcZbOJV4jvqQ4Q/RAEPtA5QnAFwpp4UpgHchmniNAJb0tcw9AWBdXQPQpwBlW93r8SUMcwcUeh9Ea7yK5Pz4E6TP99BDZ/+W1ZEGwIPqHYjQNwAtdwbj3DWgrKT1h/2Z/SAJ1LYvc4GPrXVxnRNoTN9Fm1JpGQhSAPigeiMa6HuAVjqCWMm6SRUCkkmxlO1ctxfH5I8pmtgio+6WtbNOXf0CUNbnv5y70jIhCxpE0q2k+YIUjEcomtwvKi0MgA+p7VCUz+aFPda+IDFLx4fYgu7jSUSmVlPHmQsiEMQB6NpX9qgT0RWw8VF0aYr5b01+lLoS+wSSEJsC/NH112Dm8kkAS0RExW2CgpDdXxwb7WGKxjeI5CHUAaw39wAYyLe/yKYnEj5AGyfLDBrTV4lMBEEA2vMA7appAPOj184yY9xKPclf3RCLARhufhuMx3P3HDV49UvlxZl1FBs9EgwAXesHqDcnFtS6dUtN8vyCC2PeS9GR/NRaRE6sA4a0V0D0zCW1BAzzTuoeOe6GURTADhC9ekkBaJhuovsnxoMBoN+8FogcrW0AjlJTiMZvEHlCFOuAPii4RUuBaEVtboRF+xKbeyk2kn28dj2EAFhbn140Cl2lK2lQCIANUOY26hz7WSQDcQADK67A0sYEYHdBTQyEEhOJcYBi8a0ixWdthAFY9Q5pvSDqFxWvgt05GNO3U7f75jeXmxQAG4JzJFahytIh+V9EqIU64t/JpCQNwN4P9gH0sCNQde8Q/wPMLSI3PsVwPAGwIbwD0DYZ2mWynQHzZoolPvei7xmADeFNgLZ7CRyMD0/DMDdTd/KwVz1fAHIQ1NcB5SmvCXj3s35e30SxxNfeNSSnwGKBWNd2A/S0n0SkfBn/AJl7RJ723HR9d8BcAB5SXwYpO90CBnD+AmC0UzT5bQBacvcBbgFZ114E6AU3Ox/np4DZjRQdO+ZDw+EaWAfkO6H5WRBeCirBvA6fh2muD/LFaFY7cADWxjikOR+f/dJg/guMNupK/OhXqti/LAAsCMPqk2DaI/DKyK2mc8BsG0XHTrgZejlfNgA5CNp2MN7wDIHxJ2C0UCx50ktxIj5lBWDfJ2wDaK80BObTUNAq848VIgVXbAkUBmJdyz43vAuQIpYkT4IyLaLP9GKapa3K3gHz00FXtwLKe440Sr8XTIEzrRQb/cVPYaK+FQOQWw7NPWDuBy3SCYxxKGYrdY6cEi3Ar11FAVgQBtUYIjQAUMSZPP8Oc3Yddf024rcoGf+KA8h1gvYAQIMFL1sTQKaNoqOjMskHYVsVADaE+wD6AMyjMKmFuuOuv+EHUXBVpsBiifOwthEzMyepd3yiHMWJaFatA0SSq4RNCKASlGs5RtgBtXx1KpFb2AGVoFzLMcIOqOWrU4nc/gev3Z9Qm6CY7gAAAABJRU5ErkJggg==');
    }
}
</style>
